export default __webpack_public_path__ + "static/media/slide10.fdb95bd1.jpg";